import { Component, ElementRef, OnInit, Input, Output, HostBinding, EventEmitter } from '@angular/core';
import { NotificationTemplates } from '../../templates/notification.template';
import { NotificationModel } from '../../models/notification';
import { CfCoreComponent } from '../core/core.component';

import { TemplateService } from '../../services/template-service/template.service';
/**
 * <p>Component for Core Component Notifications</p>
 */
export class CfNotificationComponent extends CfCoreComponent implements OnInit {
/**
 * It is position of notification
 */
position = 'top-right';
/**
 * It is default core styling options form SETTINGS (file: '/assets/settings/notification/settings.ts')
 * <p>There are three main properties:</p>
 * <ul>
 * <li><b>position</b>: it is notification position.
 * Default is <b>top-right</b> Can be also: <b>bottom-right</b>, <b>bottom-left</b>, <b>top-left</b>.</li>
 * <li><b>theme</b>: it is name of theme.
 * Theme will affect on notification colors(background of cantainer, colors of value and icon).</li>
 * <li><b>classes</b>: it is list of css classes separated by space.
 * It is possible to use Angualr Material <b>primary, accent, warn</b> and any other classes.</li>
 * </ul>
 */
options = {
    theme: null,
    classes: null
  };
/**
 * <p>It is Object which will recive data from Core Component <b>notification</b> property.
 * It is used in different components templates.</p>
 * <p>Example of <b>NotifcationModel</b>:</p>
 * <pre>{{'{'}}
 *  value: this.notificationValue,
 *  type: 'text'
 * {{'}'}}</pre>
 * <h4>value: any</h4>
 * It is name of property for notification value.
 * <h4>type: string</h4>
 * It is type of notification value. Can be <b>text</b>(default) or <b>icon</b>. Optional.
 */
cfNotification: NotificationModel;
/**
 * It is <b>[settings]</b> attribute of <b>cf-notification</b> c
 * omponent with json object generated by NotificationModel (described in <b>cfNotification</b> above).
 */
settings: NotificationModel;
/**
 * @hidden
 * @param {?} elementRef
 * @param {?} templateService
 */
constructor(public elementRef: ElementRef, /**@hidden */ templateService: TemplateService) {
    super(elementRef, templateService);
  }
/**
 * @hidden
 * @return {?}
 */
ngOnInit() {
    this.getMyTemplate('notification', NotificationTemplates).then(() => {
      this.options = this.activeTemplate['property'];
      this.cfNotification = this.settings;
      if (!this.cfNotification.hasOwnProperty('type')) { this.cfNotification.type = 'text'; }
      if (this.options['position'] !== '') { this.position = this.options['position']; }
      if (this.cfNotification.position && this.cfNotification.position !== '') { this.position = this.cfNotification.position; }
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-notification',
  template: "<small class=\"cf-notification-container mat-toolbar {{options?.theme}} {{options?.classes}} {{cfNotification?.classes}}\"> <span *ngIf=\"cfNotification?.type === 'text'\" class=\"cf-notification-text\" [innerHtml]=\"cfNotification?.value | safePipe\"></span>	 <md-icon *ngIf=\"cfNotification?.type === 'icon'\" class=\"cf-notification-icon {{ cfNotification?.icon?.type === 'fa' ? 'fa ' + cfNotification?.icon?.name : 'material-icons' }}\">{{cfNotification?.icon?.type === 'mi' ? cfNotification?.icon?.name : ''}}</md-icon> </small>",
  styles: ["/** * DEFAULT CORE NOTIFICATION STYLES START. Don't change them here.  * If you need style chenges - create your own styling clessaes in CUSTOM NOTIFICATION STYLES section below.  */ :host { position: absolute; z-index: 100000; } :host small { display: flex; align-items: center; justify-content: center; padding: 0px; min-width: 24px; min-height: 24px; border-radius: 50%; box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12); } :host small .cf-notification-text, :host small .cf-notification-icon { font-size: 14px; line-height: 24px; } :host small .cf-notification-text { font-weight: bold; } :host.top-right { top: -10px; right: -10px; } :host.bottom-right { bottom: -10px; right: -10px; } :host.bottom-left { bottom: -10px; left: -10px; } :host.top-left { top: -10px; left: -10px; } "]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: TemplateService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'position': [{ type: HostBinding, args: ['class', ] },],
'settings': [{ type: Input },],
};
}

function CfNotificationComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfNotificationComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfNotificationComponent.ctorParameters;
/** @type {?} */
CfNotificationComponent.propDecorators;
/**
 * It is position of notification
 * @type {?}
 */
CfNotificationComponent.prototype.position;
/**
 * It is default core styling options form SETTINGS (file: '/assets/settings/notification/settings.ts')
 * <p>There are three main properties:</p>
 * <ul>
 * <li><b>position</b>: it is notification position.
 * Default is <b>top-right</b> Can be also: <b>bottom-right</b>, <b>bottom-left</b>, <b>top-left</b>.</li>
 * <li><b>theme</b>: it is name of theme.
 * Theme will affect on notification colors(background of cantainer, colors of value and icon).</li>
 * <li><b>classes</b>: it is list of css classes separated by space.
 * It is possible to use Angualr Material <b>primary, accent, warn</b> and any other classes.</li>
 * </ul>
 * @type {?}
 */
CfNotificationComponent.prototype.options;
/**
 * <p>It is Object which will recive data from Core Component <b>notification</b> property.
 * It is used in different components templates.</p>
 * <p>Example of <b>NotifcationModel</b>:</p>
 * <pre>{{'{'}}
 *  value: this.notificationValue,
 *  type: 'text'
 * {{'}'}}</pre>
 * <h4>value: any</h4>
 * It is name of property for notification value.
 * <h4>type: string</h4>
 * It is type of notification value. Can be <b>text</b>(default) or <b>icon</b>. Optional.
 * @type {?}
 */
CfNotificationComponent.prototype.cfNotification;
/**
 * It is <b>[settings]</b> attribute of <b>cf-notification</b> c
 * omponent with json object generated by NotificationModel (described in <b>cfNotification</b> above).
 * @type {?}
 */
CfNotificationComponent.prototype.settings;
/** @type {?} */
CfNotificationComponent.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
